<template>
  <a-config-provider :locale="zhCN">
    <div class="uav-app">
      <router-view v-slot="{ Component }">
        <component :is="Component" />
      </router-view>
      <!-- <div class="map-wrapper">
        <GMap/>
      </div> -->
      <VideoModal />
    </div>
  </a-config-provider>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useMyStore } from './store'
import GMap from '/@/components/CesiumMap.vue'
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import VideoModal from '/@/components/VideoModal.vue'

export default defineComponent({
  name: 'App',
  components: { GMap, VideoModal },

  setup () {
    const store = useMyStore()
    return { zhCN }
  }
})
</script>
<style lang="scss" scoped>
.uav-app {
  width: 100%;
  height: 100%;

  .map-wrapper {
    height: 100%;
    width: 100%;
  }
}
</style>

<style lang="scss">
#uav-app {
  width: 100%;
  height: 100%
}
.cesium-viewer-bottom{
  visibility: hidden;
}
</style>
